// src/GroupUserIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var GroupUserIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "21",
    height: "18",
    viewBox: "0 0 21 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.58594 0C4.82451 0 2.58594 2.23858 2.58594 5C2.58594 7.76142 4.82451 10 7.58594 10C10.3474 10 12.5859 7.76142 12.5859 5C12.5859 2.23858 10.3474 0 7.58594 0ZM4.58594 5C4.58594 3.34315 5.92908 2 7.58594 2C9.24279 2 10.5859 3.34315 10.5859 5C10.5859 6.65685 9.24279 8 7.58594 8C5.92908 8 4.58594 6.65685 4.58594 5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.4944 5.21828C15.213 5.07484 14.9017 5.00006 14.5859 5.00006V3.00006C15.2175 3.00006 15.8402 3.14956 16.4028 3.43645C16.4648 3.46805 16.5259 3.50121 16.5859 3.5359C17.0713 3.81614 17.4931 4.19569 17.8232 4.65055C18.1942 5.16172 18.4389 5.75347 18.5372 6.37737C18.6355 7.00126 18.5847 7.63958 18.3889 8.24005C18.1931 8.84053 17.8578 9.38611 17.4107 9.83213C16.9635 10.2782 16.417 10.6119 15.816 10.8062C15.2812 10.979 14.7168 11.037 14.1595 10.9772C14.0905 10.9698 14.0216 10.9606 13.953 10.9496C13.3297 10.8497 12.739 10.6038 12.2291 10.2319L12.228 10.2311L13.407 8.61557C13.6621 8.80172 13.9576 8.92477 14.2695 8.97474C14.5813 9.02471 14.9005 9.00014 15.201 8.90302C15.5014 8.80591 15.7747 8.63903 15.9983 8.41602C16.2218 8.19302 16.3894 7.92024 16.4873 7.62001C16.5852 7.31978 16.6107 7.00063 16.5615 6.68869C16.5123 6.37675 16.39 6.08089 16.2045 5.82531C16.0191 5.56974 15.7757 5.36172 15.4944 5.21828Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18.584 18C18.584 17.475 18.4806 16.9551 18.2797 16.47C18.0788 15.9849 17.7843 15.5442 17.413 15.1729C17.0418 14.8017 16.601 14.5072 16.1159 14.3062C15.6309 14.1053 15.111 14.0019 14.5859 14.0019V12C15.268 12 15.9443 12.1163 16.5859 12.3431C16.6855 12.3783 16.7842 12.4162 16.882 12.4567C17.61 12.7583 18.2714 13.2002 18.8286 13.7574C19.3857 14.3145 19.8277 14.9759 20.1292 15.7039C20.1697 15.8017 20.2076 15.9004 20.2428 16C20.4696 16.6416 20.5859 17.3179 20.5859 18H18.584Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.5859 18H12.5859C12.5859 15.2386 10.3474 13 7.58594 13C4.82451 13 2.58594 15.2386 2.58594 18H0.585938C0.585938 14.134 3.71994 11 7.58594 11C11.4519 11 14.5859 14.134 14.5859 18Z",
          fill: "currentColor"
        }
      )
    ]
  }
);

export {
  GroupUserIcon
};
